module.exports = __webpack_public_path__ + "media/images/coupon/img-coupon-name-068c544c5698824890c39d08aa6cf0cb.png";